module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "icons-view"
  }, [_c('CellTips', [_vm._v("Icon Box")]), _vm._v(" "), _c('IconBox', {
    staticClass: "flex",
    attrs: {
      "success": "",
      "title": "success",
      "desc": "For success"
    }
  }), _vm._v(" "), _c('IconBox', {
    staticClass: "flex",
    attrs: {
      "info": "",
      "title": "info",
      "desc": "For normal info"
    }
  }), _vm._v(" "), _c('IconBox', {
    staticClass: "flex",
    attrs: {
      "warn": "",
      "title": "warn",
      "desc": "For warn info"
    }
  }), _vm._v(" "), _c('IconBox', {
    staticClass: "flex",
    attrs: {
      "danger": "",
      "title": "danger",
      "desc": "For danger info"
    }
  }), _vm._v(" "), _c('IconBox', {
    staticClass: "flex",
    attrs: {
      "waiting": "",
      "title": "waiting",
      "desc": "For waiting info"
    }
  }), _vm._v(" "), _c('CellTips', [_vm._v("Icons")]), _vm._v(" "), _c('Icon', {
    attrs: {
      "success": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "nike": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "circle": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "warn": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "download": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "info": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "cancel": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "search": ""
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "loading": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-0056e19a!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/iconsView.vue
// module id = 216
// module chunks = 0